import React from 'react';
import {Box} from "@chakra-ui/react";

interface MainLayoutProps {
    children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    return (
        <Box>
            <Box as="main" p={0} bg="gray.900" minH="100vh">
                {children}
            </Box>
        </Box>
    );
}

export default MainLayout;
